export const SET_WORKVIEW_2_ACTIVE_CATEGORY_ID = 'SET_WORKVIEW_2_ACTIVE_CATEGORY_ID'
export const SET_WORKVIEW_2_CATEGORY_USERS = 'SET_WORKVIEW_2_CATEGORY_USERS'
export const SET_MY_ASSIGNED_CHECKED = 'SET_MY_ASSIGNED_CHECKED'
export const SET_UNASSIGNED_CHECKED = 'SET_UNASSIGNED_CHECKED'
export const SET_WORKFLOW_OPTIONS = 'SET_WORKFLOW_OPTIONS'
export const SET_SELECTED_ROW = 'SET_SELECTED_ROW'
export const SET_RECORD_TO_AMEND = 'SET_RECORD_TO_AMEND'
export const SET_LIEN_FORMS = 'SET_LIEN_FORMS'
export const SET_TRADEMARK_FORMS = 'SET_TRADEMARK_FORMS'
export const SET_BUSINESS_FORMS = 'SET_BUSINESS_FORMS'
export const SET_NOTARY_FORMS = 'SET_NOTARY_FORMS'
export const SET_ORDER_FORMS = 'SET_ORDER_FORMS'
export const SET_REGISTERED_AGENT_FORMS = 'SET_REGISTERED_AGENT_FORMS'
export const SET_ATHLETE_AGENT_FORMS = 'SET_ATHLETE_AGENT_FORMS'
export const SET_STAFF_DRAFT = 'SET_STAFF_DRAFT'
export const SET_RECORD_SEARCH_QUERY = 'SET_RECORD_SEARCH_QUERY'
export const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS'
export const SET_AMENDMENT_WIZARDS = 'SET_AMENDMENT_WIZARDS'
export const SET_PAPER_REDIRECT = 'SET_PAPER_REDIRECT'
export const SET_PAPER_FILING_ERROR_MESSAGE = 'SET_PAPER_FILING_ERROR_MESSAGE'
export const SET_SELECTED_FORM = 'SET_SELECTED_FORM'
export const SET_LOADING_AMENDMENT_WIZARDS = 'SET_LOADING_AMENDMENT_WIZARDS'
export const SET_STAFF_FILING_CORRECTION_INFO = 'SET_STAFF_FILING_CORRECTION_INFO'
export const SET_ORDER_DETAILS = 'SET_ORDER_DETAILS'
export const SET_LEGACY_FILING_DETAILS = 'SET_LEGACY_FILING_DETAILS'
export const SET_WORK_VIEW_ITEM_NOTES = 'SET_WORK_VIEW_ITEM_NOTES'

export const defaultRecordSearchQuery = {
  QueryTypeID: '1',
  QueryID: '1',
  SearchMethodID: '1',
  Method: '1',
  PageNumber: '1',
  PageSize: '2500',
  QueryTypeId: '1',
}

export const initialState = {
  myAssignedChecked: false,
  unassignedChecked: false,
  activeCategoryId: 0,
  workviewCategoryUsers: [],
  workflowOptions: [],
  selectedRow: {
    RecordToAmend: null,
  },
  staffDraft: null,
  recordSearchQuery: defaultRecordSearchQuery,
  searchResults: [],
  loadingAmendmentWizards: false,
  amendmentWizards: [],
  businessForms: [],
  lienForms: [],
  registeredAgentForms: [],
  athleteAgentForms: [],
  trademarkForms: [],
  notaryForms: [],
  orderForms: [],
  showPaperFilingErrorMessage: false,
  paperFilingErrorMessage: '',
  staffFilingCorrectionInfo: null,
  orderDetails: undefined,
  legacyFilingDetails: undefined,
  workViewItemNotes: [],
}

const Workview2Reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MY_ASSIGNED_CHECKED:
      return {
        ...state,
        myAssignedChecked: action.myAssignedChecked,
      }
    case SET_UNASSIGNED_CHECKED:
      return {
        ...state,
        unassignedChecked: action.unassignedChecked,
      }
    case SET_WORKVIEW_2_ACTIVE_CATEGORY_ID:
      return {
        ...state,
        activeCategoryId: action.activeCategoryId,
      }
    case SET_WORKVIEW_2_CATEGORY_USERS:
      return {
        ...state,
        workviewCategoryUsers: action.workviewCategoryUsers,
      }
    case SET_WORKFLOW_OPTIONS: {
      return {
        ...state,
        workflowOptions: action.workflowOptions,
      }
    }
    case SET_SELECTED_ROW: {
      return {
        ...state,
        selectedRow: action.selectedRow,
      }
    }
    case SET_RECORD_TO_AMEND: {
      return {
        ...state,
        selectedRow: {
          ...state.selectedRow,
          RecordToAmend: action.record,
        },
      }
    }
    case SET_LIEN_FORMS: {
      return {
        ...state,
        lienForms: action.options,
      }
    }
    case SET_TRADEMARK_FORMS: {
      return {
        ...state,
        trademarkForms: action.options,
      }
    }
    case SET_BUSINESS_FORMS: {
      return {
        ...state,
        businessForms: action.options,
      }
    }
    case SET_ORDER_FORMS: {
      return {
        ...state,
        orderForms: action.options,
      }
    }
    case SET_NOTARY_FORMS: {
      return {
        ...state,
        notaryForms: action.options,
      }
    }
    case SET_REGISTERED_AGENT_FORMS: {
      return {
        ...state,
        registeredAgentForms: action.options,
      }
    }
    case SET_ATHLETE_AGENT_FORMS: {
      return {
        ...state,
        athleteAgentForms: action.options,
      }
    }
    case SET_STAFF_DRAFT:
      return {
        ...state,
        staffDraft: action.staffDraft,
      }
    case SET_RECORD_SEARCH_QUERY: {
      return {
        ...state,
        recordSearchQuery: action.query,
      }
    }
    case SET_SEARCH_RESULTS: {
      return {
        ...state,
        searchResults: action.results,
      }
    }
    case SET_AMENDMENT_WIZARDS: {
      return {
        ...state,
        amendmentWizards: action.amendmentWizards,
        loadingAmendmentWizards: action.loadingAmendmentWizards,
      }
    }
    case SET_LOADING_AMENDMENT_WIZARDS:
      return {
        ...state,
        loadingAmendmentWizards: action.loadingAmendmentWizards,
      }
    case SET_PAPER_REDIRECT: {
      return {
        ...state,
        selectedRow: {
          ...state.selectedRow,
          paperRedirect: action.paperRedirect,
        },
      }
    }
    case SET_PAPER_FILING_ERROR_MESSAGE:
      return {
        ...state,
        paperFilingErrorMessage: action.paperFilingErrorMessage,
        showPaperFilingErrorMessage: action.paperFilingErrorMessage ? true : false,
      }
    case SET_SELECTED_FORM: {
      return {
        ...state,
        selectedRow: {
          ...state.selectedRow,
          SelectedFormStaffDraft: action.data.staffDraft,
          SelectedFormDefinitionId: action.data.formDefinitionID,
          SelectedFormAmendmentTypeId: action.data.amendmentTypeID,
          SelectedFormFilingTypeId: action.data.filingTypeID,
        },
      }
    }
    case SET_STAFF_FILING_CORRECTION_INFO: {
      return {
        ...state,
        staffFilingCorrectionInfo: action.staffFilingCorrectionInfo,
      }
    }
    case SET_ORDER_DETAILS: {
      return {
        ...state,
        orderDetails: action.orderDetails,
      }
    }
    case SET_LEGACY_FILING_DETAILS: {
      return {
        ...state,
        legacyFilingDetails: action.legacyFilingDetails,
      }
    }
    case SET_WORK_VIEW_ITEM_NOTES: {
      return {
        ...state,
        workViewItemNotes: action.notes,
      }
    }
    default:
      return state
  }
}

export default Workview2Reducer
